import { render, staticRenderFns } from "./tipusMPDetail.vue?vue&type=template&id=1cf39f88&scoped=true"
import script from "./tipusMPDetail.vue?vue&type=script&lang=js"
export * from "./tipusMPDetail.vue?vue&type=script&lang=js"
import style0 from "./tipusMPDetail.vue?vue&type=style&index=0&id=1cf39f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf39f88",
  null
  
)

export default component.exports